import React from 'react';
import './InfoLoja.css'



const InfoLoja = (props) => {

	function resolveImage() {
		let imagem = props.imagem
		return imagem ? `${imagem}` : `assets/sem_imagem.png`
	}


	return (
		<div className="box-loja">
			<div className="row">
				<div className="col-md-4">
					<div className="pic-box-loja" >
						<img alt="imagem" src={resolveImage()} className="img-responsive" />
					</div>
				</div>

				<div className="col-md-8">
					<h1>{props.descricao}</h1>
					<p>Tempo de espera : <strong>{props.tempo_entrega}</strong></p>
					<p>Telefone para Contato : <strong>{props.TelefonesDesc}</strong></p>
					<p>Horário de funcionamento : <strong>{props.HorariosDesc}</strong> </p>
					<p>Valor mínimo para pedido : <strong>R$ {props.val_min_pedido ? props.val_min_pedido.toFixed(2) : '0.00'}</strong> </p>
					<p>Taxa de Entrega : <strong>R$ {props.taxa_entrega ? props.taxa_entrega.toFixed(2) : '0.00'}</strong> </p>
					{
						props.aberto ? (

							<span id="infoAbertura" className="LojaOpen">Loja <strong>Aberta</strong> </span>


						) : (
							<span id="infoAbertura" className="LojaClose">Loja <strong>Fechada</strong> </span>
						)
					}
				</div>
			</div>
		</div>
	);
}





export default InfoLoja;